import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MeService} from '../../../services/api/me.service';
import {TEST_PRIVILEGES} from '../../../../constants/privileges';
import {QuestionService} from '../../../services/api/question.service';
import {Question} from '../../../data/models/test/question';
import {TestService} from '../../../services/api/test.service';
import {Test} from '../../../data/models/test/test';
import {QuestionTypeService} from "../../../services/api/question-type.service";
import {formatDate} from "@angular/common";

@Component({
  selector: 'app-test',
  templateUrl: './test-questions-page.component.html',
  styleUrls: ['./test-questions-page.component.css']
})
export class TestQuestionsPageComponent implements OnInit {

  readonly PRIVILEGES = TEST_PRIVILEGES;

  test: Test | null = null;
  questions: Question[] | null = null;

  canEdit = false;

  constructor(
    private route: ActivatedRoute,
    private meService: MeService,
    private testService: TestService,
    private questionService: QuestionService,
    private questionTypeService: QuestionTypeService,
  ) {
      this.questionTypeService.questionTypes$
          .subscribe();
      this.questionTypeService.questionCategories$
          .subscribe();
  }

  ngOnInit(): void {
    const testId = +(this.route.snapshot.paramMap.get('testId') || 0);
    if (testId) {
      this.testService.getTest(testId)
        .then(test => {
          this.test = test;
          this.updatePermissions();
        });
      this.questionService.getQuestions(testId)
        .then(questions => {
          this.questions = questions;

          this.questions.forEach((question: Question) => {
            if (question.imageName) {
              this.loadImage(question);
            }
          });
        });

    }
  }

  updatePermissions(): void {
    if (this.test) {
      this.canEdit = this.test.activateDate === null && this.test.deleteDate === null &&
        this.meService.hasPrivilege(this.PRIVILEGES.UPDATE);
    }
  }


    private loadImage(question: Question) {
        this.questionService.getImage(question.imageName)
            .subscribe(image => {this.createImage(image, question);})
    }

    private createImage(image: Blob, question: Question) {
        if (image && image.size > 0) {
            const reader = new FileReader();
            reader.addEventListener("load", () => {question.imageFile = reader.result;}, false);
            reader.readAsDataURL(image);
        }
    }

    exportQuestions(): void {
            const testId = this.test?.id;
            const fileName = 'Вопросы по тесту № ' + testId;
            const downloadUrl = new URL(`/api/tests/${testId}/questions/export/${fileName}.xlsx`, window.location.href);
            window.open(downloadUrl.toString(), '_blank');
    }
}
